<div class="flex flex-col gap-1" data-test-id="filter-search">
	<label [for]="inputId()" class="font-semibold">
		{{ 'compositions.filters.search.title' | translate }}
	</label>
	<vp-autocomplete
		[inputId]="inputId()"
		[loading]="loading()"
		[minimumCharacters]="minimumCharacters"
		[options]="options()"
		[selectedOption]="selectedOption()"
		(searched)="onSearched($event)"
		(selectedValue)="onSelected($event)"
		loadingText="compositions.filters.search.loading"
		placeholder="compositions.filters.search.placeholder"
	/>
</div>
